<div class="modal-header modal-h" >
    <h5 class="modal-title" >{{discount.store_name}}</h5>
    <button type="button" class="btn-close" (click)="closeBtnClick()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-b">
    <div class="text" id="show-text-area">
        <div class="image">
            <img src="{{discount.store_logo}}" alt="">
        </div>
        <div class="discounts-info-container">
            <div *ngFor="let offer of discount.offers" class="discount-info">
                <div class="discount-value vertical-align">
                    {{ offer?.offer_text }}
                </div>
                <div class="vertical-align">
                    {{ offer?.offer_name }}
                </div>
                <button (click)="goToReferrelLink(offer)" class="btn btn-secondary">
                    Copiaza codul {{ offer?.offer_text }}
                </button>
            </div>
        </div>
    </div>
    <div class="d-flex buttons">
        <button class="btn-primary" (click)="closeBtnClick()"><span class="ficon feather icon-check-square"></span>
            Inchide
        </button>
    </div>
</div>
